import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bentornato ✦");
      const to = loc.state?.from || (u.role === "admin" ? "/admin" : "/");
      nav(to);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-28 min-h-screen">
      <div className="max-w-md mx-auto px-4">
        <span className="av-eyebrow">Area gestione</span>
        <h1 className="font-serif-display text-4xl mt-3">
          Accedi al tuo <span className="italic text-[#E5A93C]">back-office</span>
        </h1>
        <form onSubmit={submit} className="av-card p-6 mt-8 space-y-4" data-testid="login-form">
          <div>
            <label className="av-label">Email</label>
            <input
              type="email"
              required
              className="av-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="av-label">Password</label>
            <input
              type="password"
              required
              className="av-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="av-pill av-pill-gold w-full justify-center"
            data-testid="login-submit-btn"
          >
            {loading ? "Attendi…" : "Entra"}
          </button>
          <p className="text-sm text-[#A39E93] text-center">
            Non hai un account?{" "}
            <Link to="/register" className="text-[#E5A93C]" data-testid="go-register-link">
              Registrati
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
